import React, { useEffect, useRef, useState } from 'react';
import './RowActionsMenu.css';
import { useAllowedItems } from './PermissionsContext';

// items: [{ key, label, onClick, disabled, disabledTitle, danger, needs }]
// Items the current screen's permissions don't allow (Edit without Update,
// Archive/Unarchive/Delete without Delete — see PermissionsContext.js
// useAllowedItems) aren't shown; with none left, the kebab isn't either.
function RowActionsMenu({ items: allItems, ariaLabel = 'Row actions' }) {
  const items = useAllowedItems(allItems);
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  // When every option is disabled (e.g. another row's edit form is open),
  // grey out the kebab itself instead of letting it open a dropdown full of
  // unusable items — there's nothing to see in there.
  const allDisabled = items.every((item) => item.disabled);
  const disabledTitle = allDisabled ? items.find((item) => item.disabledTitle)?.disabledTitle : undefined;

  if (!items.length) return null;

  return (
    <div className="row-actions-menu" ref={containerRef}>
      <button
        type="button"
        className="row-menu-kebab"
        onClick={() => !allDisabled && setOpen((o) => !o)}
        disabled={allDisabled}
        title={disabledTitle}
        aria-label={ariaLabel}
        aria-haspopup="true"
        aria-expanded={open}
      >⋮</button>
      {open && (
        <div className="row-menu-dropdown">
          {items.map((item) => (
            <button
              key={item.key}
              type="button"
              className={`row-menu-item${item.danger ? ' danger' : ''}`}
              disabled={item.disabled}
              title={item.disabled ? item.disabledTitle : undefined}
              onClick={() => {
                if (item.disabled) return;
                setOpen(false);
                item.onClick();
              }}
            >{item.label}</button>
          ))}
        </div>
      )}
    </div>
  );
}

export default RowActionsMenu;
